import { render, staticRenderFns } from "./TableSales.vue?vue&type=template&id=a644e766&scoped=true"
import script from "./TableSales.vue?vue&type=script&lang=js"
export * from "./TableSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a644e766",
  null
  
)

export default component.exports